import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["tagName", "children", "className", "size", "disabled", "onClick", "accent"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { cnBem, forwardRefWithTag } from '@carnica/utils';
import React from 'react';
import { Text } from "../../Text";
import styles from "./styles.pcss";
var cnTabBarItem = cnBem('tabbar-item', styles);
export var TabBarItem = forwardRefWithTag(function (props, ref) {
  var _props$tagName = props.tagName,
    tagName = _props$tagName === void 0 ? 'button' : _props$tagName,
    children = props.children,
    className = props.className,
    _props$size = props.size,
    size = _props$size === void 0 ? 'm' : _props$size,
    disabled = props.disabled,
    onClickProp = props.onClick,
    accent = props.accent,
    otherProps = _objectWithoutProperties(props, _excluded);
  var onClick = function onClick(e) {
    if (!disabled) {
      onClickProp === null || onClickProp === void 0 ? void 0 : onClickProp(e);
    }
  };
  var innerProps = _objectSpread(_objectSpread({}, otherProps), {}, {
    ref: ref,
    tagName: tagName,
    onClick: onClick,
    disabled: disabled
  });
  return /*#__PURE__*/React.createElement(Text, _extends({}, innerProps, {
    className: cnTabBarItem({
      disabled: disabled,
      accent: accent,
      size: size
    }, [className]),
    variant: "body-small",
    "data-t-id": "TabBar-TabBarItem"
  }), children);
});